import { FC, ReactNode } from 'react';
import { StepperMenuItem } from './StepperMenuItem';
import { Container } from '@logz-ui/styleguide';

interface IStepperMenuProps {
  steps?: Array<ReactNode>;
  currentStep?: number;
  onStepClicked?: (step: number) => void;
}

export const StepperMenu: FC<IStepperMenuProps> = ({ steps = [], currentStep = 1, onStepClicked }) => {
  return (
    <Container sticky borderRadius={'lg'} variant={'neutral'} p={4} minWidth={'260px'} border={true}>
      {steps.map((step, index) => {
        return (
          <StepperMenuItem
            onClick={() => onStepClicked?.(index)}
            index={index}
            title={step}
            key={index}
            selected={currentStep === index + 1}
          />
        );
      })}
    </Container>
  );
};
